import React from "react";

export default function SQLServer_CONCAT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_CONCAT</h1>
      <p>This is the SQLServer_CONCAT component generated from the SQL JSON.</p>
    </div>
  );
}
